var bSlider;

bSlider = function() {
  var $, Swiper, bForm, formSlider, module, moduleName, pushIndex, pushLvlName;
  moduleName = "b-slider";
  $ = require('jquery');
  module = $("." + moduleName);
  if (module.length < 1) {
    return false;
  }
  Swiper = require('swiper');
  pushIndex = function() {
    var getter, index;
    index = this.activeIndex + 1;
    getter = module.find("." + moduleName + "__lvl-index .index");
    return getter.html(index);
  };
  pushLvlName = function() {
    var cherriesLength, cherry, cherryInstancesElem, cherryTpl, currentSlideLvlName, getter, index;
    index = this.activeIndex;
    currentSlideLvlName = $(this.slides[index]).data('lvlname');
    getter = module.find("." + moduleName + "__lvl-name");
    getter.html(currentSlideLvlName);
    cherryInstancesElem = module.find("." + moduleName + "__lvl-instances");
    cherryTpl = "<div class='" + moduleName + "__cherry'>";
    cherriesLength = cherryInstancesElem.find("." + moduleName + "__cherry").length;
    while (cherriesLength <= index) {
      cherryInstancesElem.append(cherryTpl);
      cherriesLength++;
    }
    if (cherriesLength > (index + 1)) {
      cherry = cherryInstancesElem.find("." + moduleName + "__cherry").get(0);
      return cherry.remove();
    }
  };
  formSlider = new Swiper("." + moduleName + "__main.swiper-container", {
    spaceBetween: 30,
    slidesPerView: 1,
    autoHeight: true,
    simulateTouch: false,
    allowTouchMove: false,
    on: {
      init: function() {
        pushIndex.call(this);
        return pushLvlName.call(this);
      },
      slideChange: function() {
        var stepRange;
        stepRange = require('../step-ranger/step-ranger');
        stepRange({
          actionType: 'change',
          order: this.activeIndex
        });
        pushIndex.call(this);
        return pushLvlName.call(this);
      }
    }
  });
  bForm = module.find("." + moduleName + "__b-form");
  return bForm.each(function() {
    var $this, checkInputCompletes, inputsInForm, inputsLength, nextBtn, prevBtn;
    $this = $(this);
    inputsInForm = $this.find(".jform__input");
    inputsLength = inputsInForm.length;
    checkInputCompletes = function() {
      var completedInputsCount;
      $this = $(this);
      if ($this.attr('disabled')) {
        return;
      }
      if ($this.hasClass('completed')) {
        if ($this.val() === '') {
          $this.removeClass('completed');
        }
      } else {
        if ($this.val() !== '') {
          $this.addClass('completed');
        }
      }
      completedInputsCount = 0;
      inputsInForm.each(function() {
        $this = $(this);
        if ($this.hasClass('completed')) {
          return completedInputsCount = completedInputsCount + 1;
        }
      });
      if (completedInputsCount === inputsLength) {
        return nextBtn.removeAttr('disabled');
      } else {
        return nextBtn.attr('disabled', '');
      }
    };
    inputsInForm.change(function() {
      return checkInputCompletes.call(this);
    });
    inputsInForm.keyup(function() {
      return checkInputCompletes.call(this);
    });
    nextBtn = $this.find("." + moduleName + "__next");
    prevBtn = $this.find("." + moduleName + "__prev");
    nextBtn.click(function() {
      formSlider.slideNext();
      return false;
    });
    return prevBtn.click(function() {
      formSlider.slidePrev();
      return false;
    });
  });
};

module.exports = bSlider;
